import React, { useEffect, useState } from 'react';
//import { armonizacionContable } from '../../json/armonizacionContable';
import '../InformesGestionFinanciera/informesGestionFinanciera.css';

  const DetalleInformesGestionFinanciera2026 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Integración y Rendición de Informes de Gestión Financiera Consolidada 2026</h2>
            <hr className='hr-gob'/>
          </div>
            <div style={{ width: "100%" }}>
            <table className="table table-striped table-bordered">
                      <tr>
                        <th scope="col" colspan="2"><div className="detalle_nombreLicitacion" style={{ width: "700px" }}>Documento</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>1er. Trim</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>2do. Trim</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>3er. Trim</div></th>
                        <th scope="col" colspan="2"><div style={{ width: "100px" }}>4to. Trim</div></th>
                      </tr>
            </table>
         </div>

            <div className="tabla-contenedorIGF">
            <table className="table table-striped table-bordered tabla-elementosIGF">
            <tbody>
              <tr>
                  <th scope="row" colspan="6"><div className="th-seccion">Estados e Información Contable</div></th>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado Analítico del Activo</th>
                <td>
                  <div className="div-elementosIGF">
                {/*}    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div> 
                </td>
                <td>
                  <div className="div-elementosIGF">
                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado de Actividades</th>
                <td>
                  <div className="div-elementosIGF">
                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                   </div> 
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                   </div> 
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                   </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado de Flujo de Efectivo</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Flujo_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/* <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2025/4toTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado de Situación Financiera</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado de Variación en la Hacienda Pública</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Variacion_en_Hacienda_Publica_y_Patrimonio.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                      <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                   </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div> 
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Notas a los Estados Financieros</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Notas_junio.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
              </tr>
            {/*  <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Notas de Gestión Administrativa</th>
                <td></td>
               <td>
                  <div className="div-elementosIGF">
                 {/*    <a href="http://dif.hidalgo.gob.mx/integracion_rendicion_informes_gest_financ_consolidada/2024/1erTrim/Notas_de_Gestion_Administrativa.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
              {/*    </div>
                </td>
                <td></td>
                <td></td>  
              </tr> */}
              <tr>
                  <th scope="row" colspan="6"><div className="th-seccion">Información Presupuestaria</div></th>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado Analítico de Ingresos</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */} 
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/ESTADO_ANALITICO_DE_INGRESOS.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado Analítico del Presupuesto de Egresos Clasificación Administrativa</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/2EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_CLASIF._ADMINISTRATIVA.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado Analítico del Presupuesto de Egresos Clasificación Económica</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/3Estado_Analitico_Clasificacion_Economica_Marzo.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_Economica.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_CLASIF._ECONOMICA.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado Analítico del Presupuesto de Egresos Clasificación por Objeto del Gasto</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/4EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionporObjeto_del_Gasto(Capitulo_y_Concepto).pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticoEjercicioPresupuestoEgresosClasificacionObjetoDelGasto(CapituloYConcepto).pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_por_Objeto_del_Gasto.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_COG.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
              </tr>
               <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Estado Analítico del Presupuesto de Egresos Clasificación Funcional</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/5EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */} 
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_Funcional.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_CLASIF._FUNCIONAL.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
              </tr>
              <tr>
                  <th scope="row" colspan="6"><div className="th-seccion">Información Programática</div></th>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Gasto por Categoría Programática</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/9Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/GASTO_POR_CATEGORIA_PROGRAMATICA.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td> 
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Indicadores de Resultados</th>
                <td>
                  <div className="div-elementosIGF">
                    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/IR-UTEED-1erTrim2026.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/IR_2doTrim_2025.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/IR_3erTrim_2025.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/IR-UTEED-4toTrim2025.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                  </div>
                </td>
              </tr>
              <tr>
                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                <th scope="row">Programas y Proyectos de Inversión</th>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/10Programas_y_Proyectos_de-Inversion.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>  
                </td>
                <td>
                  <div className="div-elementosIGF">
                  {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer">
                    <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                  </div>  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
  </div>


    )
}


  export default DetalleInformesGestionFinanciera2026